/**
* 获取城市信息（依赖搜索接口）
* http://10.177.40.105:13789/project/70/interface/api/476
*/
export function getCityInfoFromSearch(args) {
    function format(item) {
        if (item && item.id && item.id > 0) {
            return {
                latitude: item.latbd,
                longitude: item.lonbd,
                speed: null,
                accuracy: null,
                altitude: null,
                threeCode: item.threeCode,
                provName: item.provName,
                cityName: item.name,
                tcProvId: item.provId,
                tcCityId: item.id,
                elCityId: item.eRegion && item.eRegion.euId
            }
        }
    }

    return new Promise((resolve, reject) => {
        const response = window.AllBridge.request({
            $nodeId: args.$nodeId,
            $nodeLabel: args.$nodeLabel,
            $nodeType: args.$nodeType,
            $nodeVersion: args.$nodeVersion,
            $nodeCalcSuccessExpression: args.$nodeCalcSuccessExpression,
            url: '/actgateway/marketcenter.java.activity.resource.service/v2/city/getCityInfoFromSearch',
            method: 'get',
            withCredentials: true,
            params: {
                tcCityId: args.tcCityId,
                elCityId: args.elCityId,
                cityName: args.cityName,
                lon: args.lon,
                lat: args.lat,
                oldReturn: false,
                refreshCache: args.refreshCache,
                likeSearch: args.likeSearch
            }
        }).then(response => {
            let result = response.data && response.data.result
            if (!response.data) {
                reject({ code: 1000, message: '服务端返回结果为空' })
                return
            }
            if (!response.data.success) {
                reject({ code: response.data.code, message: response.data.message })
                return
            }

            const resultIsArray = Array.isArray(result)
            if (resultIsArray && result.length <= 0) {
                reject({ code: 1000, message: '服务端返回结果为空' })
            } else {
                if (resultIsArray) {
                    result = result.map(item => format(item))
                } else {
                    result = format(result)
                }

                return resolve(args.returnArray && !resultIsArray ? [result] : result)
            }
        }).catch(error => {
            error.code = '5000'
            reject(error)
        })
    })
}

/**
* 获取资源数据
*/
export function getResource(args) {
    return new Promise((resolve, reject) => {
        args.activityId = window._eaid

        const response = window.AllBridge.request({
            $nodeId: args.$nodeId,
            $nodeLabel: args.$nodeLabel,
            $nodeType: args.$nodeType,
            $nodeVersion: args.$nodeVersion,
            $nodeCalcSuccessExpression: args.$nodeCalcSuccessExpression,
            url: '/actgateway/marketcenter.java.activity.resource.service/v2/resource/getResource/',
            method: 'post',
            withCredentials: true,
            data: args
        }).then(response => {
            let result = response.data && response.data.result
            if (!response.data) {
                reject({ code: 1000, message: '服务端返回结果为空' })
                return
            }
            if (!response.data.success) {
                reject({ code: response.data.code, message: response.data.msg })
                return
            }

            if (!result || !result.resourceList || result.resourceList.length <= 0) {
                reject({ code: 1000, message: '服务端返回结果为空' })
            } else {
                return resolve(result)
            }
        }).catch(error => {
            error.code = '5000'
            reject(error)
        })
    })
}